import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function FrontParticipantModule() {
  const user = useSelector((state) => state.user.user);

  return (
    <section className="pt-8 pt-md-8">
      <div className="container pt-8 pb-1 pb-md-8 border-bottom">
        <div className="row align-items-center">
          <div className="col-12 col-md">
            <h3 className="mb-1">
              <FormattedMessage id="front.participantmodule.enrolltitle" />
            </h3>
            <p className="fs-lg text-muted mb-6 mb-md-0">
              <FormattedMessage id="front.participantmodule.enrollsubtitle" />
            </p>
          </div>
          <div className="col-12 col-md-auto">
            <Link to={'/'} className="btn btn-primary-soft me-1 lift">
              <FormattedMessage id="front.participantmodule.learnbtn" />
            </Link>
            {user ? (
              ''
            ) : (
              <Link to={'/trainees/apply'} className="btn btn-primary lift">
                <FormattedMessage id="front.participantmodule.enrollbtn" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
